import { z } from 'zod';
import { NumberInString } from '@mvf/zod-types';

const ProcessEnv = z.object({
  BUILD_TARGET: z.string(),
  BUILT_AT: z.string(),
  RECAPTCHA_SITE_KEY: z.string().min(1),
  MAX_DURATION_SECONDS: NumberInString,
  PROXY_DOMAIN: z.string(),
  CHEQ_SCRIPT_URL: z.string().min(1),
  CHEQ_CHANNEL: z.string().min(1),
  CHEQ_CLASS: z.string().min(1),
});

export type IProcessEnv = z.infer<typeof ProcessEnv>;

export const Environment = ProcessEnv.parse({
  BUILD_TARGET: process.env.BUILD_TARGET,
  BUILT_AT: process.env.BUILT_AT,
  RECAPTCHA_SITE_KEY: process.env.RECAPTCHA_SITE_KEY,
  MAX_DURATION_SECONDS: process.env.MAX_DURATION_SECONDS,
  PROXY_DOMAIN: process.env.PROXY_DOMAIN,
  CHEQ_SCRIPT_URL: process.env.CHEQ_SCRIPT_URL,
  CHEQ_CHANNEL: process.env.CHEQ_CHANNEL,
  CHEQ_CLASS: process.env.CHEQ_CLASS,
});
